import { RolesClient } from './EpdClient';

const rolesClient = new RolesClient(process.env.REACT_APP_API_URL);

class RoleService {
  static getRoles = async (companyId?: string | null) => {
    return await rolesClient.get(null);
  };
  static getUserAffiliatedCompaniesPage = async (page: number, pageSize: number) => {
    return await rolesClient.getUserAffiliatedCompaniesPage(page, pageSize);
  };
}
export default RoleService;
